module.exports = __webpack_public_path__ + "static/img/gfmhq.d6e1007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/gfmhq.jpg
// module id = 6z29
// module chunks = 21